import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import { SLIDER_THUMB_VISIBILITY, SLIDER_TRACK_SIZE, ACTION_COLOR_LIVESITE, ACTION_COLOR, BG_COLOR_LIVESITE, BG_COLOR } from '../consts.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".qBEvp,.sF2kj{-webkit-appearance:none}.qBEvp{width:100%}[dir] .qBEvp{margin:8px 0}.qBEvp.ekWdo{height:4px}.qBEvp.jUlLP{height:6px}[dir] .qBEvp:focus::-webkit-slider-runnable-track{background:rgba(0,0,0,.2)}[dir] .qBEvp:focus::-ms-fill-lower{background:rgba(0,0,0,.2)}[dir] .qBEvp:focus::-ms-fill-upper{background:rgba(0,0,0,.2)}[dir=ltr] .qBEvp::-webkit-slider-thumb{box-shadow:1px 1px 1px rgba(0,0,0,.2),0 0 1px hsla(0,0%,5%,.2)}[dir=rtl] .qBEvp::-webkit-slider-thumb{box-shadow:-1px 1px 1px rgba(0,0,0,.2),0 0 1px hsla(0,0%,5%,.2)}[dir] .qBEvp:not(.isTX7):focus.Ypwpq::-webkit-slider-thumb,[dir] .qBEvp:not(.isTX7):hover.Ypwpq::-webkit-slider-thumb{background-color:var(--ricos-native-text-color,var(--ricos-action-color-fallback,#0261ff));border:4px solid var(--ricos-native-text-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .qBEvp:not(.isTX7):focus:not(.Ypwpq)::-webkit-slider-thumb,[dir] .qBEvp:not(.isTX7):hover:not(.Ypwpq)::-webkit-slider-thumb{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));border:4px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .qBEvp.isTX7.Ypwpq::-webkit-slider-thumb{background-color:var(--ricos-native-text-color,var(--ricos-action-color-fallback,#0261ff));border:4px solid var(--ricos-native-text-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .qBEvp.isTX7:not(.Ypwpq)::-webkit-slider-thumb{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));border:4px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .qBEvp::-webkit-slider-runnable-track{background:transparent;border:0 solid #cfd8dc;border-radius:3px;box-shadow:0 0 0 rgba(0,0,0,.2),0 0 0 hsla(0,0%,5%,.2)}.qBEvp:not(.ekWdo)::-webkit-slider-runnable-track{height:6px;transition:all .2s ease;width:100%}[dir] .qBEvp:not(.ekWdo)::-webkit-slider-runnable-track{cursor:pointer}.qBEvp.ekWdo::-webkit-slider-runnable-track{height:4px!important}.qBEvp::-webkit-slider-thumb{-webkit-appearance:none;height:16px;width:16px}[dir] .qBEvp::-webkit-slider-thumb{background:transparent;border:4px solid transparent;border-radius:8px;box-shadow:none;cursor:pointer;margin-top:-5px}.qBEvp::-moz-range-track{height:6px;transition:all .2s ease;width:100%}[dir] .qBEvp::-moz-range-track{background:transparent;border:0 solid #cfd8dc;border-radius:3px;box-shadow:0 0 0 rgba(0,0,0,.2),0 0 0 hsla(0,0%,5%,.2);cursor:pointer}.qBEvp::-moz-range-thumb{box-sizing:border-box;height:16px;width:16px}[dir] .qBEvp::-moz-range-thumb{background:transparent;border:4px solid transparent;border-radius:8px;box-shadow:none;cursor:pointer}.qBEvp::-ms-track{color:transparent;height:6px;transition:all .2s ease;width:100%}[dir] .qBEvp::-ms-track{background:transparent;border-color:transparent;border-width:8px 0;cursor:pointer}[dir] .qBEvp::-ms-fill-lower{background:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));border:0 solid #cfd8dc;border-radius:6px;box-shadow:0 0 0 rgba(0,0,0,.2),0 0 0 hsla(0,0%,5%,.2)}[dir] .qBEvp::-ms-fill-upper{background:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));border:0 solid #cfd8dc;border-radius:6px;box-shadow:0 0 0 rgba(0,0,0,.2),0 0 0 hsla(0,0%,5%,.2)}.qBEvp::-ms-thumb{height:16px;width:16px}[dir] .qBEvp::-ms-thumb{background:transparent;border:4px solid transparent;border-radius:8px;box-shadow:none;cursor:pointer;margin-top:0}";
var styles = {"wrapperSlider":"sF2kj","slider":"qBEvp","small_track":"ekWdo","medium_track":"jUlLP","slider_fixed_thumb":"isTX7","slider_livesite":"Ypwpq"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Slider = (props) => {
  const mergedStyles = mergeStyles({ styles, theme: props.theme });
  const {
    min = 0,
    max = 10,
    tabIndex = 0,
    onChange,
    dataHook,
    ariaProps,
    value,
    onChangeCommitted,
    languageDir,
    thumbVisibility = SLIDER_THUMB_VISIBILITY.fixed,
    trackSize = SLIDER_TRACK_SIZE.medium,
    step,
    liveSiteWiring = false,
    ariaLabel
  } = props;
  const [fillPercentage, setFillPercentage] = useState(0);
  const track = {
    fill: liveSiteWiring ? ACTION_COLOR_LIVESITE : ACTION_COLOR,
    unFilled: liveSiteWiring ? BG_COLOR_LIVESITE : BG_COLOR,
    gradientDeg: languageDir === "rtl" ? "270deg" : "90deg"
  };
  const bgStyle = {
    background: `linear-gradient(${track.gradientDeg} ,${track.fill} ${fillPercentage}%, ${track.unFilled} ${fillPercentage + 0.1}%)`
  };
  const isFixedThumb = thumbVisibility === SLIDER_THUMB_VISIBILITY.fixed;
  const onKeyUp = (event) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft":
      case "Home":
      case "End":
      case "PageUp":
      case "PageDown":
        onChangeCommitted == null ? void 0 : onChangeCommitted(event.target.valueAsNumber);
        break;
      default:
        return;
    }
  };
  const onKeyDown = (e) => {
    switch (e.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft":
      case "Home":
      case "End":
      case "PageUp":
      case "PageDown":
        onChange == null ? void 0 : onChange(e.target.valueAsNumber);
        break;
      default:
        return;
    }
  };
  useEffect(() => {
    setFillPercentage(100 * (value - min) / (max - min));
  }, [value]);
  return /* @__PURE__ */ React.createElement(
    "input",
    __spreadProps(__spreadValues({}, ariaProps), {
      "aria-label": ariaLabel,
      tabIndex,
      type: "range",
      className: classNames(
        mergedStyles.slider,
        mergedStyles.wrapperSlider,
        mergedStyles[trackSize],
        {
          [mergedStyles.slider_fixed_thumb]: isFixedThumb,
          [mergedStyles.slider_livesite]: liveSiteWiring
        }
      ),
      "data-hook": dataHook,
      onChange: (e) => onChange(e.target.valueAsNumber),
      value,
      min,
      max,
      step,
      onMouseUp: (e) => onChangeCommitted == null ? void 0 : onChangeCommitted(e.target.valueAsNumber),
      onTouchEnd: (e) => onChangeCommitted == null ? void 0 : onChangeCommitted(e.target.valueAsNumber),
      onKeyUp,
      onKeyDown,
      style: bgStyle
    })
  );
};

export { Slider as default };
//# sourceMappingURL=Slider.js.map
